import React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Checkmark } from "react-checkmark";
import _ from "lodash";
import Headerdash from "./head";
import Sidebar from "./sidebar";

// Page Html
export default function SpeakingMockResultPage(props) {

  const [mockTests, setMockTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMockTestData = async () => {
      try {
        const response = await fetch('/api/fetch-speakingmocktestdata', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        setMockTests(data);
      } catch (err) {
        setError('Error fetching mock test data');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchMockTestData();
  }, []);

  // if (loading) return <p>Loading...</p>;
  // if (error) return <p>{error}</p>;

  // Data from The Main Page ID props
  const q_data = mockTests;

  console.log("Idadadwa", q_data);

  const main_heading = "mockpage";

  // Lowercase the string
  const lowercasedString = _.toLower(main_heading);

  // Remove spaces
  const stringWithoutSpaces = _.replace(lowercasedString, /\s/g, "");

  console.log("Heading:", stringWithoutSpaces);

  function Box(props) {
    return (
      <div> <div className=" h-32 max-w-6xl bg-gray-100 border-t-2  ml-11 mb-4">
      <tbody>
        <tr>
          <td className="pt-10 pl-2 pr-4">{props.no}</td>
          <td class="pt-10 pl-12 md:pl-16 mr-60 w-44 ">{props.title}</td>
          <td className="pl-64 pt-10 ">
          <Checkmark size='small' color='#D3D3D3'/>
          </td>
          <td className="  ml-2 pt-10 pl-10 md:pl-32 ">
            <span class=" font-semibold py-1 px-2 rounded-sm ">{props.score}</span>
          </td>
          <td class=" pt-10 pl-20 md:pl-36">
            {/* <a class="nav-link" href="http://localhost:3000/openquestion">
              <i class=""></i>
              <p className="underline decoration-1 text-center">
                Open Question
              </p>
            </a> */}
            <Link
        className="nav-link"
        to={`/${stringWithoutSpaces}/result/${encodeURIComponent(props._id)}`}
      >
              <i className=""></i>
              <p className="underline decoration-1 text-center">
              View Result
              </p>
            </Link>
          </td>
        </tr>
      </tbody>
    </div></div>
     
    );
  }

  // End

  function createCard(q_data, index) {
    return <Box no={index + 1} title={q_data.mockTestName} _id={q_data._id} score={q_data.averageScore} />;
  }
  // End

  ////////////////////////////////////  Pagination ////////////////////////////////////

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(q_data.length / itemsPerPage);

  const maxPagesToShow = 7;
  const halfMaxPages = Math.floor(maxPagesToShow / 2);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const getPageNumbers = () => {
    const pageNumbers = [];

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else if (currentPage <= halfMaxPages) {
      for (let i = 1; i <= maxPagesToShow; i++) {
        pageNumbers.push(i);
      }
    } else if (currentPage > totalPages - halfMaxPages) {
      for (let i = totalPages - maxPagesToShow + 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      for (
        let i = currentPage - halfMaxPages;
        i <= currentPage + halfMaxPages;
        i++
      ) {
        pageNumbers.push(i);
      }
    }

    return pageNumbers;
  };

  const pageNumbers = getPageNumbers();

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, q_data.length);

  ///////////////////////////End//////////////////////////////////////////////////

  return (
    <div>
       <Headerdash />
      <Sidebar />
      <section className=" relative top-24 md:left-[290px] bg-gray-100 max-w-6xl py-5 px-5 md:px-10 mx-4 rounded-sm">
        <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl ml-1 text-center md:text-start">
          {props.heading}
        </h1>

        {/* BreadCrum */}

        <nav aria-label="Breadcrumb" className="flex ml-16 mt-6  md:ml-80 ">
          <ol className="flex overflow-hidden rounded-lg border border-gray-200 text-gray-600">
            <li className="flex items-center">
              <a
                href="mocktest/speaking"
                className="flex h-10 items-center gap-1.5 bg-gray-100 px-4 transition hover:text-gray-900"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                  />
                </svg>

                <span className="ms-1.5 text-xs font-medium"> Speaking </span>
              </a>
            </li>

            <li className="relative flex items-center">
              <span className="absolute inset-y-0 -start-px h-10 w-4 bg-gray-100 [clip-path:_polygon(0_0,_0%_100%,_100%_50%)] rtl:rotate-180"></span>

              <a
                href="/mocktest/writing"
                className="flex h-10 items-center bg-white pe-4 ps-8 text-xs font-medium transition hover:text-gray-900"
              >
                Writing
              </a>
            </li>

            <li className="relative flex items-center">
              <span className="absolute inset-y-0 -start-px h-10 w-4 bg-gray-50 [clip-path:_polygon(0_0,_0%_100%,_100%_50%)] rtl:rotate-180"></span>

              <a
                href="/mocktest/reading"
                className="flex h-10 items-center bg-white pe-4 ps-8 text-xs font-medium transition hover:text-gray-900"
              >
                Reading
              </a>
            </li>
            <li className="relative flex items-center">
              <span className="absolute inset-y-0 -start-px h-10 w-4 bg-gray-50 [clip-path:_polygon(0_0,_0%_100%,_100%_50%)] rtl:rotate-180"></span>

              <a
                href="/mocktest/listening"
                className="flex h-10 items-center bg-white pe-4 ps-8 text-xs font-medium transition hover:text-gray-900"
              >
                Listening
              </a>
            </li>
            <li className="relative flex items-center">
              <span className="absolute inset-y-0 -start-px h-10 w-4 bg-gray-50 [clip-path:_polygon(0_0,_0%_100%,_100%_50%)] rtl:rotate-180"></span>

              <a
                href="/mocktest/fullmocktest"
                className="flex h-10 items-center bg-white pe-4 ps-8 text-xs font-medium transition hover:text-gray-900"
              >
                Full Mock Test
              </a>
            </li>
          </ol>
        </nav>

        {/* Tables */}

        <table className="ml-8 mt-8">
          <thead className="text-gray-700">
            <tr>
              <th class="md:pl-6 pr-12">S. No</th>
              <th class="pr-20 md:pr-80">Title</th>
              <th class="sm:block hidden mt-2 pr-12 md:pr-24">Badge</th>
              <th class="pr-24 md:pr-32">Score</th>
              <th class="md:p-3">ScoreCard</th>
            </tr>
          </thead>
        </table>

        {q_data
          .slice(startIndex, endIndex)
          .map((item, index) => createCard(item, startIndex + index))}

        {/* End */}
      </section>
      <div className="relative max-w-3xl mx-8 top-24 md:left-[460px] pt-4 bg-white">
        <ol className="flex justify-center gap-1 text-xs font-medium">
          {currentPage > 1 && (
            <li>
              <button
                onClick={() => handleClick(1)}
                className="inline-flex h-8 w-8 items-center justify-center rounded border border-gray-100 bg-white text-gray-900 rtl:rotate-180"
              >
                <span className="sr-only">First Page</span>1
              </button>
            </li>
          )}

          <li>
            <button
              onClick={() => handleClick(Math.max(currentPage - 1, 1))}
              disabled={currentPage === 1}
              className="inline-flex h-8 w-8 items-center justify-center rounded border border-gray-100 bg-white text-gray-900 rtl:rotate-180"
            >
              <span className="sr-only">Prev Page</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-3 w-3"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </li>

          {pageNumbers.map((number) => (
            <li key={number} className="flex">
              <button
                onClick={() => handleClick(number)}
                className={`block h-8 w-8 rounded border ${
                  number === currentPage
                    ? "border-blue-600 bg-violet-600 text-white"
                    : "border-gray-100 bg-white text-center leading-8 text-gray-900"
                }`}
              >
                {number}
              </button>
            </li>
          ))}

          <li>
            <button
              onClick={() => handleClick(Math.min(currentPage + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="inline-flex h-8 w-8 items-center justify-center rounded border border-gray-100 bg-white text-gray-900 rtl:rotate-180"
            >
              <span className="sr-only">Next Page</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-3 w-3"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </li>

          {currentPage < totalPages && (
            <li>
              <button
                onClick={() => handleClick(totalPages)}
                className="inline-flex h-8 w-8 items-center justify-center rounded border border-gray-100 bg-white text-gray-900 rtl:rotate-180"
              >
                <span className="sr-only">Last Page</span>
                {totalPages}
              </button>
            </li>
          )}
        </ol>
      </div>
    </div>
  );
}
